import I18n from 'i18n-js';
import _get from 'lodash/get';
import { emptyAction, logOutCleanUp } from 'actions/app-actions';

export class OVOError extends Error {
  name = 'OVOError';

  constructor(message, errorCode = -1) {
    super(message);
    this.errorCode = errorCode;
  }
}

export const OVOErrorCode = {
  multiBookings: -400,
  userCancelMFA: -401,
  failToCreateTxn: -500,
  failToGetMFADetails: -501,
  failToVerifyMFA: -502,
};

export const getErrorHttpStatus = error => _get(error, 'status');

export const isUnauthorizedError = error => getErrorHttpStatus(error) === 401;

export const isTooManyRequestError = error => getErrorHttpStatus(error) === 429;

export const getErrorMessage = error => {
  if (!error) {
    return '';
  }
  const message = _get(error, ['response', 'message']);
  if (message) {
    return message;
  }
  if (isUnauthorizedError(error)) {
    return I18n.t('invalidTokenModal.sessionTimeoutContent');
  }
  if (isTooManyRequestError(error)) {
    return I18n.t(
      'v2.error.quote.getQuoteFailedError.description.tooManyRequest',
    );
  }
  const errorMsg = _get(error, 'message');
  if (errorMsg) {
    return errorMsg;
  }
  if (error.toString) {
    return error.toString();
  }
  return I18n.t('v2.error.quote.getQuoteFailedError.description.unknown');
};

export const logOutIfStatus401 = error => {
  if (isUnauthorizedError(error)) {
    return logOutCleanUp();
  }
  return emptyAction();
};

export const getDeliveryErrors = deliveryErrors => {
  if (!deliveryErrors) {
    return [];
  }

  return Object.entries(deliveryErrors).map(([deliveryID, errors]) => {
    const errorMessages = errors
      .map(error => {
        const errorCode = _get(error, 'errorCode');
        const title = _get(error, 'title');
        const message = _get(error, 'message');

        // When title is empty, display error code and message
        // When title is not empty, display error code, title and message
        if (title && title.trim()) {
          return `[${errorCode}] ${title}. ${message}`;
        } else {
          return `[${errorCode}] ${message}`;
        }
      })
      .join(', ');

    return {
      deliveryID,
      displayText: `Delivery ${deliveryID} has error(s): ${errorMessages}`,
    };
  });
};
